export const SET_USER_WATCHERS = 'SET_USER_WATCHERS';
export const SET_USER_WATCHER = 'SET_USER_WATCHER';
export const UNSET_USER_WATCHER = 'UNSET_USER_WATCHER';
export const SET_WATCHERS = 'SET_WATCHERS';
export const SET_WATCHER = 'SET_WATCHER';
export const SET_WATCHER_WITH_COUNTS = 'SET_WATCHER_WITH_COUNTS';
export const CREATE_WATCHER = 'CREATE_WATCHER';
export const DELETE_WATCHER = 'DELETE_WATCHER';
export const SET_DOCUMENT_AS_READ = 'SET_DOCUMENT_AS_READ';
export const SET_ALL_DOCUMENTS_AS_READ = 'SET_ALL_DOCUMENTS_AS_READ';
export const DELETE_WATCHER_QUERY = 'DELETE_WATCHER_QUERY';
export const SET_WATCHER_EXISTS = 'SET_WATCHER_EXISTS';
export const UNSET_WATCHER_EXISTS = 'UNSET_WATCHER_EXISTS';
export const ADD_QUERIES_TO_WATCHER_EXISTS = 'ADD_QUERIES_TO_WATCHER_EXISTS';
export const DELETE_QUERY_FROM_WATCHER_EXISTS =
  'DELETE_QUERY_FROM_WATCHER_EXISTS';
